import { CalendarBase } from "./CalendarBase";
import { CalendarBaseSetting } from "../../firestore/Types/UI/CalendarSetting";
import { BookingView, SessionView } from "../../firestore/Types/BookingSchema";
import { CalendarSession } from "./CalendarSession";
import { CalendarBooking } from "./CalendarBooking";
import { days } from "../../Utils/TimeSlotUtils";
import { useEffect, useState } from "react";

export function Calendar({ classNameCss="", bookings, filteredSessions, showBookings, calendarWeek, setCalendarWeek, onClick }: { classNameCss:string, bookings: BookingView[], filteredSessions: SessionView[],showBookings?:boolean, calendarWeek: number, setCalendarWeek: React.Dispatch<React.SetStateAction<number>>, onClick?: (booking: BookingView | SessionView, infoType:string) => void }) {
    const calendarBaseSetting = { showDate: true, showTopGutter: true } as CalendarBaseSetting;
    const dates = [] as number[];
  
    const [showSessions, setShowSessions] = useState(false);
    
    useEffect(() => {
        const showOnChange = () => {
            if (showBookings === true) {
                setShowSessions(false);
            } else {
                setShowSessions(true);
            }
        }

        showOnChange();
    }, [showBookings]);
    function renderBookings(day: string) {
        return (<>
            {bookings.map((booking, index) => (
                (booking.Day.toLowerCase() === day.toLowerCase() &&
                    <CalendarBooking key={index} onClick={onClick} booking={booking}/>
                )
            ))}
        </>)
    }

    function renderSessions(day: string) {
        return (<>
            {filteredSessions.map((session, index) => (
                (session.Day.toLowerCase() === day.toLowerCase() &&
                    <CalendarSession key={index} onClick={onClick} session={session}/>
                )
            ))}
        </>)
    }
    function getCurrentWeekDates() {
        const currentDate = new Date();
        const firstDayOfWeek = currentDate.getDate() - currentDate.getDay() + 1; // Assuming week starts on Monday


        for (let i = 0; i < 7; i++) {
            const date = new Date(currentDate.setDate(firstDayOfWeek + i));
            dates.push(date.getDate());
        }

    }
    getCurrentWeekDates();
    function renderCalendarDaySessions(day: string) {
        //proof of concept
        return (
            <>
                {renderSessions(day)}
            </>
        )
    }
    function renderCalendarDayBookings(day: string) {
        //proof of concept
        return (
            <>
              {renderBookings(day)}</>
          
        )
    }
    function renderLeadingSectionOverlay(day: string) {
        return (
            (<div className="calendar-leading">

            </div>)
        )
    }
    const secondaryLayer = () => {
        return (
            <>
              
            </>
        )
    }
    const mainLayer = () => {
        return (
            <>
                {days.map((day, index) => (
                    <div key={index}>
                        {renderLeadingSectionOverlay(day)}
                        <div className="grid grid-row-height-15mins">
                            {(showBookings)?renderCalendarDayBookings(day):<></>}
                            {(showSessions)?renderCalendarDaySessions(day):<></>}
                        </div>
                    </div>
                ))}
            </>
        )

    }
    const gutterLayer = ()=>{
        return (<>
            
       
        </>)
    }
    return (
        <CalendarBase classNameCss={classNameCss} mainLayer={mainLayer} secondaryLayer={secondaryLayer} calendarSetting={calendarBaseSetting} gutterLayer={gutterLayer} week={calendarWeek} setWeeek={setCalendarWeek}></CalendarBase>
    );
}